import React from 'react'

import { Menu, Footer } from '@niimko/drupal_menu'

import { HeaderComponent } from '@/components/Header';
import { BodyComponent } from './Body';
import ThemeContext, { themes } from '@/theme/context'
import { Calltoaction } from '@/components/Calltoaction';
import { Slider } from '@/components/Slider';
import { Message } from '@/pages/main_page/components/Message'

export const Diag = (props) => {
    return (
        <ThemeContext.Provider value={themes.diag}>
            <HeaderComponent {...props} />
            <Menu {...props}/>
            {/* <Message {...props} /> */}
            <Slider
                background='/themes/diag/images/slider.svg'
                header='Оценка качества образования первокурсников, их базовой и психологической подготовки к&nbsp;обучению'
            />
            <BodyComponent {...props}/>
            <Calltoaction {...props} />
            <Footer {...props}/>
        </ThemeContext.Provider>
    )
}